import { Flex } from "antd";

export const ActionsFooter = ({ children, style, className }) => {
  return (
    <div className={`sticky-bottom bg-white p-2 ${className}`} style={style}>
      <Flex gap={8}>{children}</Flex>
    </div>
  );
};
